import moment from 'moment';

export const dateFormat = (dateCreated) =>  {
  let dateFormatted = moment(dateCreated).format('dddd ### DD-MM-YYYY, HH:mm');
  return dateFormatted.replace('###', 'd.');
};

export const simpleDateFormat = dateCreated =>  moment(dateCreated).format('DD/MM/YYYY');
